import React from 'react';
import { Link } from 'react-router-dom';
// @material-ui/core components
import withStyles from '@material-ui/core/styles/withStyles';
import PropTypes from 'prop-types';

// core components
import Table from 'components/Table/Table.jsx';
import Button from 'components/CustomButtons/Button.jsx';
import PageTitle from 'components/inc/PageTitle.jsx';
import { connect } from 'react-redux';

import style from 'assets/jss/material-kit-pro-react/views/componentsSections/contentAreas.jsx';
import { getProjectList } from '../../actions/project';
import LoadingComponent from 'components/inc/LoadingComponent.jsx';
import styles from 'assets/jss/customStyle.jsx';
import GridContainer from 'components/Grid/GridContainer.jsx';
import GridItem from 'components/Grid/GridItem.jsx';

class ProjectList extends React.Component {
  constructor() {
    super();
    this.state = {
      loading: true,
    };
  }

  componentDidMount() {
    if (
      !this.props.projectData ||
      (Object.keys(this.props.projectData).length === 0 &&
        this.props.projectData.constructor === Object)
    ) {
      this.props.loadProjectLists().then((res) => {
        if (
          Object.keys(this.props.projectData).length === 0 &&
          this.props.projectData.constructor === Object
        ) {
          this.context.router.history.push('/create-project');
        }
      });
    }
  }

  render() {
    const { classes, loading, projectData, isFetching } = this.props;
    const projectTableRows = [];
    let index = 0;
    if (projectData && Object.keys(projectData).length > 0) {
      console.log('Inside projectData');
      for (const key in projectData) {
        index += 1;
        let val = projectData[key];
        let rowContent = [];
        rowContent.push(index);
        rowContent.push(<Link to={`/projects/${val._id}`}>{val.title}</Link>);
        if (val.projectStatus === 'Draft') {
          rowContent.push(
            <div className='projectStatus'>
              <Link to={`/projects/${val._id}`}>
                <Button
                  type='button'
                  size='sm'
                  style={styles.statusWidth}
                  color='danger'
                  round
                >
                  Draft
                </Button>
              </Link>
              <Link to={`/projects/${val._id}/create-sprint`}>
                <Button
                  type='button'
                  size='sm'
                  style={styles.statusWidth}
                  color='success'
                  round
                >
                  Add Sprint
                </Button>
              </Link>
            </div>
          );
        } else if (val.projectStatus === 'In Progress') {
          rowContent.push(
            <div className='projectStatus'>
              <Link to={`/projects/${val._id}`}>
                <Button
                  type='button'
                  size='sm'
                  style={styles.statusWidth}
                  color='warning'
                  round
                >
                  In Progress
                </Button>
              </Link>
              <Link to={`/projects/${val._id}/create-sprint`}>
                <Button
                  type='button'
                  size='sm'
                  style={styles.statusWidth}
                  color='success'
                  round
                >
                  Add Sprint
                </Button>
              </Link>
            </div>
          );
        } else {
          rowContent.push(
            <div className='projectStatus'>
              <Link to={`/projects/${val._id}`}>
                <Button
                  type='button'
                  size='sm'
                  style={styles.statusWidth}
                  color='grey'
                  round
                >
                  Completed
                </Button>
              </Link>
              <Link to={`/projects/${val._id}/create-sprint`}>
                <Button
                  type='button'
                  size='sm'
                  style={styles.statusWidth}
                  color='success'
                  round
                >
                  Add Sprint
                </Button>
              </Link>
            </div>
          );
        }
        projectTableRows.push(rowContent);
      }
    }

    return (
      <div>
        <GridContainer alignItems='center' justify='space-between'>
          <GridItem xs={12} md={6}>
            <PageTitle title='My Projects' />
          </GridItem>
          <GridItem xs={12} md={6}>
            <div style={{ textAlign: 'right', paddingRight: '1rem' }}>
              <Link className='title-nav-link' to={`/create-project`}>
                <Button size='sm' color='success' round>
                  Start New Project
                </Button>
              </Link>
            </div>
          </GridItem>
        </GridContainer>

        <LoadingComponent isLoading={isFetching || loading}>
          <Table
            striped={true}
            tableHead={['#', 'Project Name', 'Status']}
            tableData={projectTableRows}
            customCellClasses={[
              classes.textCenter,
              classes.textLeft,
              classes.textRight,
            ]}
            customClassesForCells={[0, 1, 2]}
            customHeadCellClasses={[
              classes.textCenter,
              classes.textLeft,
              `text-align-right padding-right-4`,
            ]}
            customHeadClassesForCells={[0, 1, 2]}
          />
        </LoadingComponent>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  isFetching: state.project.isFetching,
  projectListData: state.project.listData,
  projectData: state.project.data,
});

const mapDispatchToProps = (dispatch) => ({
  loadProjectLists: () => dispatch(getProjectList()),
});

ProjectList.contextTypes = {
  router: PropTypes.object.isRequired,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(style)(ProjectList));
